import { getDetailLabel } from '@/shared/copy/details';
import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { SuiteRunStatus } from '@flowqa/shared';

export type SuiteRunSortDirection = 'asc' | 'desc';
export type SuiteRunSortKey =
  | 'suiteName'
  | 'status'
  | 'tests'
  | 'durationMs'
  | 'timestamp'
  | 'runNumber'
  | 'runId';

export const suiteRunDefaultSortKey: SuiteRunSortKey = 'timestamp';
export const suiteRunDefaultSortDirection: SuiteRunSortDirection = 'desc';

export const suiteRunSortOptions: Array<{
  key: SuiteRunSortKey;
  label: string;
}> = [
  { key: 'suiteName', label: 'Suite' },
  { key: 'status', label: getDetailLabel('status') },
  { key: 'tests', label: getDetailLabel('tests') },
  { key: 'durationMs', label: getDetailLabel('duration') },
  { key: 'timestamp', label: 'Executed' },
  { key: 'runNumber', label: getDetailLabel('run') },
  { key: 'runId', label: getDetailLabel('details') },
];

export const suiteRunSortFieldMap: Record<SuiteRunSortKey, string> = {
  suiteName: 'suiteName',
  status: 'status',
  tests: 'tests',
  durationMs: 'durationMs',
  timestamp: 'timestamp',
  runNumber: 'runNumber',
  runId: 'runId',
};

export const suiteRunColumnOptions: Array<{
  field: string;
  label: string;
  mandatory?: boolean;
}> = [
  { field: 'name', label: 'Suite', mandatory: true },
  { field: 'status', label: getDetailLabel('status') },
  { field: 'tests', label: getDetailLabel('tests') },
  { field: 'runNumber', label: getDetailLabel('run') },
  { field: 'output', label: getDetailLabel('output') },
  { field: 'runId', label: getDetailLabel('details') },
];

export const suiteRunStatusOptions: Array<{
  value: SuiteRunStatus;
  label: string;
}> = [
  { value: 'passed', label: 'Passed' },
  { value: 'failed', label: 'Failed' },
  { value: 'errored', label: 'Errored' },
  { value: 'skipped', label: 'Skipped' },
];

export const suiteRunDefaultColumnVisibilityModel: GridColumnVisibilityModel = {
  name: true,
  status: true,
  tests: true,
  runNumber: true,
  output: true,
  runId: true,
};
